module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_123-614bc82c2a9f25935c3215dfc21cf418.png";